module.exports = __webpack_public_path__ + "static/img/2.3c56307.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fafafa/2.png
// module id = 2HUv
// module chunks = 0